import React from 'react';
import IsConnectedAndAccess from '../../IsConnected/IsConnectedAndAccess'
import NewMember from './newMember'

class ParselNewMember extends React.Component {

 render() {
   const {...props} = this.props
   return (
     <IsConnectedAndAccess SuperAdmin={true} Access={"delca"} Component={NewMember} {...props}/>
   )
 }
}



export default ParselNewMember;
